import { useContext, useEffect, useState } from 'react'

import { Modal, Input } from '../ui_new'
import { Send } from '@material-ui/icons'
import { AddComment, Close } from '../../assets/icons'
import { NotificationContext, SingleDocumentContext, UserContext } from '../../context'
import CommentsView from './CommentsView'

const SingleDocumentCommentModal = ({ onClose, section, variable, publicView }) => {
  
  const { user } = useContext(UserContext)
  const { setNotification } = useContext(NotificationContext)
  const { document, addPublicComment, newComments, submitComments, clearNewComments } = useContext(SingleDocumentContext)

  const [comment, setComment] = useState('')
  const [sectionsComments, setSectionsComments] = useState([])

  useEffect(() => {
    const comments = ([...(document?.comments || []), ...newComments]).filter((comment) => {
      if(section) {
        return comment.section?.index === section.index
      }
      return true
    })
    setSectionsComments(comments)
  }, [document, section, newComments])

  const addComment = () => {

    let commentText = comment.trim()
    if(!commentText) {
      setNotification({ msg: "Le commentaire ne peut pas être vide", type: 'danger' })
      return
    }
    const newComment = {
      author: {
        firstname: user?.firstname || 'Prénom',
        lastname: user?.lastname || 'Nom',
        email: user?.email || '',
        id: `${user?.id || ''}`,
        type: user?.validation_access || 'client'
      },
      date: Date.now(),
      content: commentText,
    }
    if(section) {
      newComment.section = section
    }
    if(variable) {
      newComment.variable = variable
    }
    addPublicComment(newComment)
    setComment('')
  }

  const handleSendComments = async () => {
    await submitComments()
    onClose()
  }

  const handleClose = () => {
    if(!publicView && newComments.length > 0) {
      handleCancelComments() 
    }
    onClose()
  }

  const handleCancelComments = () => {
    clearNewComments()
  }

  return (
    <Modal onClose={onClose} className="modal-v2 modal-v2--mid">
      <div className='modal-v2__heading'>
        <div>
          <h2>Commentaires</h2>
        </div>
        <div className="buttons-row">
          <button className='button button--with-icon button--transparent btn--medium' onClick={handleClose}><span className='icon'><Close /></span>{(newComments.length > 0 && !publicView) ? 'Annuler' : 'Fermer'}</button>
          {newComments.length > 0 && <button className='button button--with-icon button--primary-light btn--medium' onClick={handleSendComments}><span className='icon'><Send /></span>Envoyer</button>}
        </div>
      </div>
      <div className='modal-v2__body'>
        <div className='comments-list'>
          <CommentsView commentSections={[{
              ...section,
              title: section?.content || variable?.display_name || '',
              comments: [...sectionsComments]
            }]}
            canAddComment={false}
            modal={true}
            variableValue={variable?.value}
          />
          {[...sectionsComments].length === 0 && (
            <div className='no-comments'>Aucun commentaire n'a été ajouté pour le moment</div>
          )}
        </div>
          <div className="comment-form pb-4">
            <div className="input-wrapper">
              <Input
                value={comment}
                type="string"
                onChange={(e) => setComment(e.target.value)}
                className={comment ? 'not-empty' : ''}
                label={'Ajouter un commentaire'}
                placeholder=' - '
                required />
              <button className="btn btn--primary-light btn--circle desktop" onClick={addComment}><AddComment /></button>
            </div>
          </div>
          <div className="modal-v2__buttons-footer mobile">
            <button className='btn btn--primary-light btn--large btn--with-icon w-full' onClick={addComment}><span className='icon'><AddComment /></span>Comenter</button>
        </div>
      </div>
    </Modal>
  )
}

export default SingleDocumentCommentModal
